@if(homeCompetitor && awayCompetitor){
  <a href="javascript:void(0)" (click)="linkToPoolUser.emit(homeCompetitor.getPoolUser())">
    <span ngClass="{'bg-success': hasQualified(Home)}">{{homeCompetitor.getName()}}</span>
  </a>  
  <span class="px-2">{{getScore(homeCompetitor, awayCompetitor)}}</span>
  <a href="javascript:void(0)" (click)="linkToPoolUser.emit(awayCompetitor.getPoolUser())">
    <span ngClass="{'bg-success': hasQualified(Away)}">{{awayCompetitor.getName()}}</span>
  </a>  
}